import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../https.service';
import { URLUtils } from '../urlUtils';

/**
 * Appointments (admin console).
 *
 * Every endpoint lives on the admin API, so all calls go through the `sendRe*`
 * side of HttpService. Those methods take the query string already
 * interpolated, so params are built and encoded here.
 *
 * The list, the summary cards and the filter dropdowns all accept the same
 * parameters: hand each of them the object `AppointmentsComponent.params()`
 * builds and the three can never describe different sets of appointments.
 */
@Injectable({
  providedIn: 'root'
})
export class AppointmentsService {

  constructor(private httpService: HttpService) {}

  private toQuery(params: any): string {
    if (!params) {
      return '';
    }

    const parts: string[] = [];

    Object.keys(params).forEach(key => {
      const value = params[key];

      if (value === null || value === undefined || value === '') {
        return;
      }

      // Multi-selects go over as one comma-joined value; the API splits them.
      const flat = Array.isArray(value) ? value.join(',') : value;

      if (flat === '') {
        return;
      }

      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(flat)}`);
    });

    return parts.length ? `?${parts.join('&')}` : '';
  }

  getAppointments(params?: any): Observable<any> {
    return this.httpService.sendReGetRequest(
      URLUtils.getAppt + this.toQuery(params)
    ) as Observable<any>;
  }

  getSummary(params?: any): Observable<any> {
    return this.httpService.sendReGetRequest(
      URLUtils.getApptSummary + this.toQuery(params)
    ) as Observable<any>;
  }

  getFilterOptions(params?: any): Observable<any> {
    return this.httpService.sendReGetRequest(
      URLUtils.getApptFilters + this.toQuery(params)
    ) as Observable<any>;
  }

  addNote(appointmentId: string, payload: any): Observable<any> {
    return this.httpService.sendRePutRequest(
      URLUtils.apptNotes(appointmentId), payload
    ) as Observable<any>;
  }

  updateSettlement(appointmentId: string, payload: any): Observable<any> {
    return this.httpService.sendRePatchRequest(
      URLUtils.apptSettlement(appointmentId), payload
    ) as Observable<any>;
  }
}
